module.exports = __webpack_public_path__ + "img/banner.237b4055.png";